import { PlayerColor } from '@colonist/game-states';
import { MechanicValidator } from './MechanicValidator.ts';
export class MechanicValidatorLargestArmy extends MechanicValidator {
    getLargestArmyPlayerState(player) {
        if (player == PlayerColor.None) return {};
        const largestArmyPlayerState = this.largestArmyState[player];
        if (largestArmyPlayerState === undefined) throw new Error(`No largestArmyPlayerState for player ${player}`);
        return largestArmyPlayerState;
    }
    getPlayerWithLargestArmy() {
        for(const key in this.largestArmyState){
            const playerColor = Number(key);
            const largestArmyPlayerState = this.getLargestArmyPlayerState(playerColor);
            if (largestArmyPlayerState.hasLargestArmy) return playerColor;
        }
        return PlayerColor.None;
    }
    doesBankHaveLargestArmyCard() {
        const playerWithLargestArmyCard = this.getPlayerWithLargestArmy();
        return playerWithLargestArmyCard == PlayerColor.None;
    }
    constructor(playerValidators, mapValidator, largestArmyState){
        super(playerValidators, mapValidator);
        this.largestArmyState = largestArmyState;
    }
}
